import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import {
  SolidcoreTwo,
  CrunchTwo,
  BlinkTwo,
  FitnessSF,
  NeouThree,
  WellnessCoach,
  EightFitThree,
  Ifeel,
} from '@assets/icons'

import Divider from '@components/Divider'

import Container from '../../Home.style'
import * as Style from './FeaturedPartners.style'

export default function Wellness() {
  return (
    <Style.Wrapper>
      <Container>
        <Row>
          <Col xxs={12} xl={3}>
            <Style.Header>
              <FormattedMessage
                id="smb_acquisition_home.featured_partners.gyms.title"
                values={{
                  span: (...chunks) => <span>{chunks}</span>,
                }}
              />
            </Style.Header>
          </Col>

          <Col xxs={6} xl={2}>
            <Style.PartnerIcon src={SolidcoreTwo} alt="Solidcore" />
          </Col>

          <Col xxs={6} xl={2}>
            <Style.PartnerIcon src={CrunchTwo} alt="Crunch" />
          </Col>

          <Col xxs={6} xl={2}>
            <Style.PartnerIcon src={BlinkTwo} alt="Blink" />
          </Col>

          <Col xxs={6} xl={2}>
            <Style.PartnerIcon src={FitnessSF} alt="Fitness SF" />
          </Col>
        </Row>

        <Style.DividerWrapper>
          <Divider />
        </Style.DividerWrapper>

        <Row>
          <Col xxs={12} xl={3}>
            <Style.Header>
              <FormattedMessage
                id="smb_acquisition_home.featured_partners.apps.title"
                values={{
                  span: (...chunks) => <span>{chunks}</span>,
                }}
              />
            </Style.Header>
          </Col>

          <Col xxs={12} xl={2}>
            <Style.PartnerIcon src={NeouThree} alt="Neou" />

            <Style.PartnerWrapper>
              <Style.PartnerTitle>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_1.title" />
              </Style.PartnerTitle>

              <Style.PartnerDescription>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_1.description" />
              </Style.PartnerDescription>
            </Style.PartnerWrapper>
          </Col>

          <Col xxs={12} xl={2}>
            <Style.PartnerIcon src={WellnessCoach} alt="Wellness Coach" />

            <Style.PartnerWrapper>
              <Style.PartnerTitle>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_2.title" />
              </Style.PartnerTitle>

              <Style.PartnerDescription>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_2.description" />
              </Style.PartnerDescription>
            </Style.PartnerWrapper>
          </Col>

          <Col xxs={12} xl={2}>
            <Style.PartnerIcon src={EightFitThree} alt="8fit" />

            <Style.PartnerWrapper>
              <Style.PartnerTitle>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_3.title" />
              </Style.PartnerTitle>

              <Style.PartnerDescription>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_3.description" />
              </Style.PartnerDescription>
            </Style.PartnerWrapper>
          </Col>

          <Col xxs={12} xl={2}>
            <Style.PartnerIcon src={Ifeel} alt="IFeel" />

            <Style.PartnerWrapper>
              <Style.PartnerTitle>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_4.title" />
              </Style.PartnerTitle>

              <Style.PartnerDescription>
                <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_4.description" />
              </Style.PartnerDescription>
            </Style.PartnerWrapper>
          </Col>
        </Row>

        <Style.DividerWrapper>
          <Divider />
        </Style.DividerWrapper>

        <Row>
          <Col xxs={12} xl={3}>
            <Style.Header>
              <FormattedMessage
                id="smb_acquisition_home.featured_partners.personal_trainer.title"
                values={{
                  span: (...chunks) => <span>{chunks}</span>,
                }}
              />
            </Style.Header>
          </Col>

          <Col xxs={12} xl={8}>
            <Style.PartnerWrapper>
              <Style.PartnerTitle>
                <FormattedMessage id="smb_acquisition_home.featured_partners.personal_trainer.personal_trainer_1.title" />
              </Style.PartnerTitle>

              <Style.PartnerDescription>
                <FormattedMessage id="smb_acquisition_home.featured_partners.personal_trainer.personal_trainer_1.description" />
              </Style.PartnerDescription>
            </Style.PartnerWrapper>
          </Col>
        </Row>
      </Container>
    </Style.Wrapper>
  )
}
